/* PACKAGES */
import React from 'react';

/* UTILS */
import { fillArray } from '../../utils/array';
import { getIndex } from '../../utils/slider';

/* STYLES */
import s from './Slider.module.scss';

const SliderNav = ({ infinite, totalUniqueSlides, widthSubColumn, totalSubColumns, index, goToSlide }) => {
	const navIndex = getIndex(infinite, totalUniqueSlides, false, widthSubColumn, totalSubColumns, index);

	const handleNavClick = (e) => {
		e.preventDefault();
		const toIndex = e.currentTarget.value;
		goToSlide((parseInt(toIndex, 10) + infinite), e);
	};

	return (
		<div className={s.slider_nav}>
			<div className={s.slider_nav_buttons}>
				{
					fillArray(totalUniqueSlides, (slide, i) => (
						// eslint-disable-next-line react/no-array-index-key
						<button type="button" className={[s.slider_nav_button, (i === (navIndex - infinite) ? s.slider_nav_button__active : null)].join(' ')} key={`pagination-${i}`} value={i} onClick={handleNavClick} aria-label={`Slider pagination ${i}`} />
					))
				}
			</div>
		</div>
	);
};

export default SliderNav;
